<template>
	<v-main>
		<v-container class="fill-height" fluid>
			<v-row align="center" justify="center">
				<v-col cols="8" sm="8" md="8" lg="8" xl="4">
					<CardPersonalizado>
						<v-card-title class="mb-3">
							<AppLogo />
						</v-card-title>
						<v-row align="center" v-if="loading" justify="center" class="pa-4">
							<v-progress-linear color="primary" indeterminate />
						</v-row>
						<v-card-text class="pb-0">
							Nome
							<v-text-field
								v-model="nome"
								label="Nome"
								solo
								background-color="#FAFAFA"
								type="text"
								required
								hide-details
								class="mb-3"
								:disabled="loading"
							/>
							Cidade
							<v-select
								label="Cidade"
								v-model="cidade"
								solo
								background-color="#FAFAFA"
								:items="cidades"
								item-text="nome"
								item-value="nome"
								item-color="red"
								color="red"
								hide-details=""
								class="mb-3"
							></v-select>
							E-mail
							<v-text-field
								v-model="email"
								label="E-mail"
								solo
								background-color="#FAFAFA"
								type="email"
								required
								:disabled="loading"
								hide-details
								class="mb-3"
							/>
							<v-row>
								<v-col cols="6">
									Senha
									<v-text-field
										solo
										placeholder="senha"
										v-model="senha"
										@click:append="show = !show"
										:type="show ? 'text' : 'password'"
										class="mb-3"
										hide-details
									>
										<template v-slot:append>
											<v-icon color="red" @click="show = !show">
												{{ show ? 'mdi-eye' : 'mdi-eye-off' }}
											</v-icon>
										</template>
									</v-text-field>
								</v-col>
								<v-col cols="6">
									Confirmar senha
									<v-text-field
										solo
										placeholder="senha"
										v-model.lazy="confirmaSenha"
										@click:append="show2 = !show2"
										:type="show2 ? 'text' : 'password'"
										class="mb-3"
										hide-details
									>
										<template v-slot:append>
											<v-icon color="red" @click="show2 = !show2">
												{{ show2 ? 'mdi-eye' : 'mdi-eye-off' }}
											</v-icon>
										</template>
									</v-text-field>
								</v-col>
							</v-row>
						</v-card-text>
						<v-card-actions>
							<v-row>
								<v-col cols="6">
									<v-btn v-if="!loading" to="Signin" color="red" text large width="100%">
										Voltar
									</v-btn>
								</v-col>
								<v-col cols="6">
									<v-btn
										v-if="!loading"
										color="red"
										@click="signup"
										large
										width="100%"
										class="white--text"
									>
										Cadastrar
									</v-btn>
								</v-col>
							</v-row>
						</v-card-actions>
					</CardPersonalizado>
				</v-col>
			</v-row>
		</v-container>
	</v-main>
</template>
<script>
import { mapActions } from 'vuex'
import AppLogo from '../components/widgets/AppLogo'
import CardPersonalizado from '../components/shared/cardPersonalizado.vue'

export default {
	components: { AppLogo, CardPersonalizado },
	data: function () {
		return {
			nome: '',
			email: '',
			senha: '',
			show: false,
			show2: false,
			confirmarSenha: '',
			confirmaSenha: '',
			cidade: 'Jataí',
			loading: false,
			cidades: [
				{ uf: 'GO', nome: 'Jataí' },
				{ uf: 'GO', nome: 'Rio Verde' },
				{ uf: 'TO', nome: 'Palmas' },
			],
		}
	},
	methods: {
		...mapActions(['showError', 'showSuccess']),
		async signup() {
			try {
				this.loading = true
				if (this.nome.length < 3) return this.showError('Nome muito curto')

				if (
					!String(this.email)
						.toLowerCase()
						.match(
							/^(([^<>()[\]\\.,:\s@"]+(\.[^<>()[\]\\.,:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
						)
				)
					return this.showError('Email inválido!')

				if (this.cidade.length < 3) return this.showError('Cidade inválida')

				if (this.senha.length < 3) return this.showError('Senha muito curta!')

				if (this.senha !== this.confirmaSenha) return this.showError('Confirmação de Senha diferente da Senha!')

				const response = await this.axios.post('/usuarios', {
					nome: this.nome,
					email: this.email,
					cidade: this.cidade,
					senha: this.senha,
				})
				this.showSuccess('Usuário cadstrado com sucesso!')
				this.resetaCampos()

				if (response.status == 204) {
					this.showSuccess('Usuário cadastrado com sucesso!')
					this.resetaCampos()
					this.$router.push('/signin')
				}
			} catch (error) {
				this.showError(error)
			} finally {
				this.loading = false
			}
		},
		resetaCampos() {
			this.nome = this.senha = this.confirmaSenha = this.email = ''
			this.cidade = this.cidades[0]
		},
	},
}
</script>
